import React from 'react';

const sections = [
    {
        heading: 'Introduction',
        paragraphs: [
            'This Privacy Policy outlines the practices of Pawansut Holdings Limited regarding the collection, use, disclosure, and protection of personal information of individuals who visit our website, mobile application, or use our services.',
            'FinnCube is dedicated to safeguarding your privacy and ensuring the security of your personal information.',
            'By accessing our website or using our services, you agree to the terms and conditions of this Privacy Policy.',
        ],
    },
    {
        heading: 'Information We Collect',
        paragraphs: [
            'We may gather personal information from you when you willingly provide it to us, for example, by filling out forms on our website, communicating with us via email or phone, or applying for our services.',
            'The types of personal information we may collect include:',
        ],
        items: [
            'Contact information such as name, email address, phone number, and postal address.',
            'Photographic identification or proof of address documents.',
            'Information about your financing needs or preferences.',
            'Information about your interactions with our website and services.',
        ],
    },
    {
        heading: 'Use of Personal Information',
        paragraphs: [
            'We may use the personal information we collect for the following purposes:',
        ],
        items: [
            'To provide our services and process your financing applications.',
            'To communicate with you regarding inquiries, applications, or account-related matters.',
            'To personalize your experience and improve our website and services.',
            'To send marketing or promotional materials with your consent.',
            'To comply with legal obligations or respond to lawful requests from public authorities.',
        ],
    },
    {
        heading: 'Disclosure of Personal Information',
        paragraphs: [
            'We may disclose your personal information to third parties in the following circumstances:',
        ],
        items: [
            'With your consent or at your direction.',
            'To our affiliates, subsidiaries, or related entities for business purposes.',
            'To service providers who assist us in operating our business and providing services.',
            'To comply with legal obligations, enforce our policies, or protect our rights, property, or safety.',
            'In connection with a merger, acquisition, or sale of all or part of our business.',
            'Important: We do not sell, trade, or rent your personal information to third parties for their marketing purposes.',
        ],
    },
    {
        heading: 'Data Security',
        paragraphs: [
            'We implement reasonable physical, technical, and administrative security measures to protect the personal information we collect.',
            'However, no method of transmission over the Internet or electronic storage is completely secure. While we strive to protect your personal information, we cannot guarantee absolute security.',
        ],
    },
    {
        heading: 'Your Rights',
        paragraphs: [
            'You have certain rights regarding your personal information, subject to applicable law. These rights may include:',
        ],
        items: [
            'Accessing, correcting, or deleting your personal information.',
            'Restricting or objecting to the processing of your personal information.',
            'Withdrawing consent for certain processing activities.',
            'Requesting portability of your personal information.',
            'Filing a complaint with a supervisory authority.',
        ],
    },
    {
        heading: 'Cookies and Tracking Technologies',
        paragraphs: [
            'Our website may use cookies and similar tracking technologies to enhance your browsing experience and collect information about how you use our site.',
            'You can manage your cookie preferences through your browser settings.',
        ],
    },
    {
        heading: 'Contact Us',
        paragraphs: [
            'If you have any questions, concerns, or requests regarding this Privacy Policy or the processing of your personal information, please contact us:',
            'Email: Care@finncube.com',
            'Phone: +91 9017339057',
        ],
    },
    {
        heading: 'Changes to This Privacy Policy',
        paragraphs: [
            'We may update this Privacy Policy from time to time. Any changes will become effective once the revised policy is posted on our website.',
            'We encourage you to review this Privacy Policy periodically to stay informed about how we collect, use, and protect your personal information.',
            'By continuing to use our website or services after changes are posted, you acknowledge and agree to the revised terms.',
        ],
    },
];

function PrivacyPolicy() {
    return (
        <div style={styles.page}>
            <div style={styles.container}>
                <div style={styles.header}>
                    <div>
                        <p style={styles.eyebrow}>Legal</p>
                        <h1 style={styles.title}>Privacy Policy</h1>
                        <p style={styles.subtitle}>This policy explains how we collect, use, disclose, and protect your personal information when you use our website or services.</p>
                    </div>
                    {/* <div style={styles.meta}>
                        <span style={styles.metaLabel}>Last updated</span>
                        <strong>March 10, 2026</strong>
                    </div> */}
                </div>

                <div style={styles.card}>
                    {sections.map((section) => (
                        <section key={section.heading} style={styles.section}>
                            <h2 style={styles.sectionHeading}>{section.heading}</h2>
                            {section.paragraphs.map((paragraph) => (
                                <p key={paragraph} style={styles.paragraph}>{paragraph}</p>
                            ))}
                            {section.items ? (
                                <ul style={styles.list}>
                                    {section.items.map((item) => (
                                        <li key={item} style={styles.listItem}>{item}</li>
                                    ))}
                                </ul>
                            ) : null}
                        </section>
                    ))}
                </div>
            </div>
        </div>
    );
}

const styles = {
    page: {
        height: '100vh',
        minHeight: '100vh',
        background: 'linear-gradient(180deg, #fff7ed 0%, #fffaf5 45%, #f8fafc 100%)',
        overflowY: 'auto',
        padding: '32px 20px 48px',
    },
    container: {
        width: '100%',
        maxWidth: '1080px',
        margin: '0 auto',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: '24px',
        flexWrap: 'wrap',
        marginBottom: '24px',
    },
    eyebrow: {
        margin: '0 0 8px',
        color: '#ea580c',
        fontSize: '0.92rem',
        fontWeight: 800,
        letterSpacing: '0.16em',
        textTransform: 'uppercase',
    },
    title: {
        margin: '0 0 10px',
        fontSize: 'clamp(2rem, 4vw, 3.25rem)',
        color: '#0f172a',
    },
    subtitle: {
        margin: 0,
        color: '#475569',
        fontSize: '1.08rem',
        lineHeight: 1.6,
        maxWidth: '760px',
    },
    meta: {
        minWidth: '180px',
        background: '#ffffff',
        border: '1px solid #fed7aa',
        borderRadius: '18px',
        padding: '16px 18px',
        boxShadow: '0 10px 30px rgba(234, 88, 12, 0.08)',
        color: '#0f172a',
    },
    metaLabel: {
        display: 'block',
        marginBottom: '6px',
        color: '#64748b',
        fontSize: '0.85rem',
        textTransform: 'uppercase',
        letterSpacing: '0.12em',
        fontWeight: 700,
    },
    card: {
        background: '#ffffff',
        border: '1px solid #e2e8f0',
        borderRadius: '28px',
        padding: '32px',
        boxShadow: '0 24px 80px rgba(15, 23, 42, 0.08)',
    },
    section: {
        marginBottom: '28px',
    },
    sectionHeading: {
        margin: '0 0 12px',
        fontSize: '1.45rem',
        fontWeight: 800,
        color: '#0f172a',
    },
    paragraph: {
        margin: '0 0 14px',
        color: '#334155',
        fontSize: '1rem',
        lineHeight: 1.75,
    },
    list: {
        margin: '0 0 8px 22px',
        padding: 0,
        color: '#334155',
    },
    listItem: {
        marginBottom: '10px',
        fontSize: '1rem',
        lineHeight: 1.7,
    },
};

export default PrivacyPolicy;
